import { Grid, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { EvesButton } from '@/common/components/atoms/button/button';
import { IAppContextModel } from '@/store/app/types';
import { useSelector } from 'react-redux';
import { InlineLoader } from '../../atoms/inlineLoader/inlineLoader';
import { disableLoaderForOnce } from '@/common/utils/loadingService';
import { setAutoLoader } from '@/store/app/reducer';
import store from '@/store';
import { useTranslation } from 'react-i18next';
import styles from './dataTable.module.scss';
import AutoRefreshIcon from '../../../../assets/img/dashboard/RefreshSVG.svg';
import { autoRefresh } from '@/common/utils/autoRefreshConfig';
interface ITableRefreshComponentPropsModel {
  componentName?: string;
  autoRefreshStatus?: boolean;
  intervalsAndFunctions?: { interval: number; func: () => void }[];
  hideLabel?: boolean;
  multiple?: boolean;
  interval?: number;
  onAutoRefreshChange?: (enabled: boolean) => void;
  onRefresh: (params?: any) => void;
}

let autoRefreshIntervals: any = [];
let autoRefreshInterval;
export default function TableRefreshComponent(
  props: ITableRefreshComponentPropsModel
) {
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(
    props.autoRefreshStatus
  );

  const appContext: IAppContextModel = useSelector(
    (state: any) => state.appContext
  );

  const { t: translate } = useTranslation();

  useEffect(() => {
    if (autoRefreshEnabled) {
      startAutoRefreshIntervals();
    } else {
      clearAutoRefreshIntervals();
    }
  }, [autoRefreshEnabled]);

  useEffect(() => {
    return () => {
      clearAutoRefreshIntervals();
    };
  }, []);

  const interval = props.interval ?? autoRefresh.DEFAULT;

  const toggleAutoRefresh = () => {
    setAutoRefreshEnabled((current) => {
      const next = !current;
      props.onAutoRefreshChange?.(next);
      return next;
    });
  };

  const startAutoRefreshIntervals = () => {
    if (!props.multiple || !autoRefreshEnabled || !props.intervalsAndFunctions?.length) {
      return;
    }
    if (autoRefreshIntervals?.length > 0) {
      return;
    }
    autoRefreshIntervals = props.intervalsAndFunctions.map(({ interval, func }) => {
      return window.setInterval(() => {
        disableLoaderForOnce();
        store.dispatch(setAutoLoader(true));
        func();
      }, interval);
    });
  };
  useEffect(() => {
    if (props.multiple || !autoRefreshEnabled) {
      return;
    }
    autoRefreshInterval = window.setInterval(() => {
      disableLoaderForOnce();
      store.dispatch(setAutoLoader(true));
      props.onRefresh();
    }, interval) as any;

    return () => {
      if (autoRefreshInterval != null) {
        window.clearInterval(autoRefreshInterval);
        autoRefreshInterval = null;
      }
    };
  }, [autoRefreshEnabled, interval, props.multiple]);

  const clearAutoRefreshIntervals = () => {
    if (autoRefreshIntervals?.length > 0) {
      autoRefreshIntervals.forEach((intervalId) => {
        window.clearInterval(intervalId);
      });
      autoRefreshIntervals = [];
    }
    if (autoRefreshInterval != null) {
      window.clearInterval(autoRefreshInterval);
      autoRefreshInterval = null;
    }
  };

  const onRefreshClick = () => {
    if (!props.multiple) {
      props.onRefresh();
    } else {
      props.intervalsAndFunctions &&
        props.intervalsAndFunctions.forEach(({ func }) => {
          func();
        });
    }
  };

  return (
    <>
      <Grid item className={styles.autoRefresh}>
        <Tooltip
          title={`${translate('general.tooltips.refresh')}`}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: 'common.white',
                color: 'black',
                borderStyle: 'solid',
                borderWidth: '1px',
              },
            },
          }}
          followCursor={false}
          placement={'bottom-start'}
          enterNextDelay={500}
        >
          <Grid item>
            <EvesButton
              isAction={true}
              onClick={onRefreshClick}
              data-cy={`${props.componentName}-manual-refresh`}
              style={{
                background: '#3D3AD3',
                //  height:'40px'
              }}
            >
              {!appContext.showLoader &&
              appContext.showAutoLoader &&
              autoRefreshEnabled ? (
                <InlineLoader showLoader={true} />
              ) : (
                <RefreshIcon></RefreshIcon>
              )}
            </EvesButton>
          </Grid>
        </Tooltip>

        {props.hideLabel && (
          <Tooltip
            title={`${translate('Auto Refresh')}`}
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'common.white',
                  color: 'black',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                },
              },
            }}
            followCursor={false}
            placement={'bottom-start'}
            enterNextDelay={500}
          >
            <Grid item>
              <EvesButton
                isAction={true}
                onClick={toggleAutoRefresh}
                data-cy={`${props.componentName}-auto-refresh`}
                style={{
                  background: autoRefreshEnabled ? '#3D3AD3' : '#999',
                  //  height:'40px',
                  '& :hover': {
                    background: autoRefreshEnabled ? '#3D3AD3' : '#999',
                  },
                }}
              >
                <img src={AutoRefreshIcon} />
              </EvesButton>
            </Grid>
          </Tooltip>
        )}
      </Grid>
    </>
  );
}
